import { useState } from 'react';
import { FormikProvider, useFormik } from 'formik';
import { useTranslation, Trans } from 'react-i18next';

import { useAuth } from '../../context/Auth';
import { IUser } from '../../types/model';

import { Button } from '../../components/UI';
import { InputCode } from '../../components/form';

const OtpModal = ({ onSubmit }: { onSubmit: (...params: any) => void }) => {
  const [error, setError] = useState();
  const [isVerificationEmailResent, setIsVerificationEmailResent] =
    useState(false);

  const { t } = useTranslation();

  const { user } = useAuth();

  const { email } = user as IUser;

  const formik = useFormik({
    initialValues: {
      code: '',
    },
    onSubmit: (values: any) => {
      onSubmit(values.code);
    },
  });

  const resendEmail = () => {};

  return (
    <div className="px-12 py-4 h-full justify-center text-center flex flex-col items-center gap-4 max-w-xl">
      <p className="text-lg font-bold">{t('verifyTotp.title')}</p>
      <div className="px-12">
        <Trans i18nKey="verifyEmail.subtitle" email={email}>
          <span className="text-grey-30">email sent to</span>
          <span className="text-black dark:text-white font-semibold">
            {{ email }}
          </span>
          <span>insert code</span>
        </Trans>
      </div>
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
          <div className="mt-12 flex justify-center">
            <InputCode
              name="code"
              id="code"
              numberOfDigits={6}
              formik={formik}
              label={t('verifyTotp.form.label.code')}
              errorMessage={error}
            />
          </div>
          <div className="mt-10">
            <Button
              type="submit"
              variant="primary"
              size="large"
              buttonClass="w-64"
              loading={formik.isSubmitting}
            >
              {t('verifyTotp.form.continue')}
            </Button>
          </div>
        </form>
      </FormikProvider>
      <div>
        <span className="text-grey-80 dark:text-grey-30">
          {t(
            !isVerificationEmailResent
              ? 'verifyEmail.notReceived'
              : 'verifyEmail.resent'
          )}
        </span>
        <button
          className="text-sm text-black dark:text-white font-semibold"
          onClick={() => resendEmail()}
        >
          {!isVerificationEmailResent && t('verifyEmail.sendNew')}
        </button>
      </div>
    </div>
  );
};

export default OtpModal;
